import { graphql } from "~/gql";

export const ALL_CLIENTS_QUERY = graphql(/* GraphQL */ `
  query FindAllClients($offset: Int, $limit: Int) {
    allClients(offset: $offset, limit: $limit) {
      total
      clients {
        id
        name
        externalReference
        type
        excludeTax
      }
    }
  }
`);
